import { useState } from "react";
import { Formik } from "formik";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

import ImageUploader, {
  uploadBas64ToS3,
} from "../../../../components/utilities/ImageUploader";
import HelpButton from "../../../../components/utilities/HelpButton";
import { postNotification } from "../../../../components/utilities/Notifications";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import { postData } from "../../../../components/utilities/UtilityFunctions";

export default function ProfileTab(props) {
  const { user, setUser } = props;
  const [processing, setProcessing] = useState(false);
  const socialOptions = [
    { key: "Facebook", prefix: "facebook.com/" },
    { key: "Instagram", prefix: "instagram.com/" },
    { key: "Twitter", prefix: "twitter.com/" },
    { key: "Twitch", prefix: "twitch.tv/" },
    { key: "YouTube", prefix: "youtube.com/" },
    {
      key: "Discord",
      prefix: "Discord ID",
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            <HelpButton
              title={`In Discord, select Settings > Advanced > Developer Mode. Once the Developer Mode is on, right click on your User Name in any chat window and select "Copy ID". This should be a string of 18 numbers`}
            />
          </InputAdornment>
        ),
      },
    },
  ];
  return (
    <>
      <Formik
        initialValues={{
          profileFileId: user?.profileFileId || "",
          bannerFileId: user?.bannerFileId || "",
          nickname: user?.nickname || "",
          bio: user?.bio || "",
          socials: user?.socials || {},
        }}
        onSubmit={async (values) => {
          try {
            setProcessing(true);
            if (values.profileImage) {
              // upload image to s3
              let newFile = await uploadBas64ToS3(values.profileImage);
              delete values.profileImage;
              if (newFile.fileId) {
                values.profileFileId = newFile.fileId;
              }
            }
            if (values.bannerImage) {
              // upload image to s3
              let newFile = await uploadBas64ToS3(values.bannerImage);
              delete values.bannerImage;
              if (newFile.fileId) {
                values.bannerFileId = newFile.fileId;
              }
            }

            if (!values.bannerFileId || values.bannerFileId === "") {
              delete values.bannerFileId;
            }

            if (!values.profileFileId || values.profileFileId === "") {
              delete values.profileFileId;
            }

            var apiUser = await postData(`/users/${user.id}`, {
              body: {
                set: values,
              },
            });

            setUser({
              ...user,
              ...apiUser,
            });
            postNotification("success", "User updated");
          } catch (err) {
            postNotification("error", err);
          }
          setProcessing(false);
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  Profile Picture
                </Typography>
                <ImageUploader
                  values={values}
                  label={`${user?.firstName || ""} ${
                    user?.lastName || ""
                  }`.trim()}
                  name="profileImage"
                  setFieldValue={setFieldValue}
                  fileId={values.profileFileId}
                  defaultUrl={user?.profileFile?.url}
                  aspectW={1}
                  aspectY={1}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  Cover Photo
                </Typography>
                <ImageUploader
                  values={values}
                  label={`${user?.firstName || ""} ${
                    user?.lastName || ""
                  }`.trim()}
                  fileId={values.bannerFileId}
                  name="bannerImage"
                  setFieldValue={setFieldValue}
                  defaultUrl={user?.bannerFile?.url}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.nickname && errors.nickname)}
                  helperText={touched.nickname && errors.nickname}
                  name="nickname"
                  value={values.nickname}
                  label="Nickname"
                  variant="outlined"
                  fullWidth
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              {socialOptions.map((socialOption, index) => {
                const { key, prefix, InputProps } = socialOption;
                return (
                  <Grid item xs={12} key={index}>
                    <TextField
                      name={`socials.${key}`}
                      value={values.socials?.[key]}
                      label={key}
                      variant="outlined"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {prefix}
                          </InputAdornment>
                        ),
                        ...InputProps,
                      }}
                    />
                  </Grid>
                );
              })}
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.bio && errors.bio)}
                  helperText={touched.bio && errors.bio}
                  name="bio"
                  value={values.bio}
                  label="Bio"
                  variant="outlined"
                  fullWidth
                  onBlur={handleBlur}
                  onChange={handleChange}
                  multiline
                  rows={5}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="success"
                  fullWidth
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      {Boolean(processing) && <ModalLoadingFull />}
    </>
  );
}
